_ = require 'underscore'
$ = require 'jquery'
ApiPromise = require 'app/scripts/network/api-promise'
AutocompleteMemberAvatar = require 'app/scripts/views/organization/invite-member-autocomplete-avatar'
AutoCompleteMultiBoardGuestAlert = require 'app/scripts/views/organization/invite-member-autocomplete-multi-board-guest-alert'
Auth = require 'app/scripts/db/auth'
Promise = require 'bluebird'
React = require 'react'
ReactDOM = require '@trello/react-dom-wrapper'
t = require('app/scripts/views/internal/recup-with-helpers')('org_members')
l = require 'app/scripts/lib/localize'
{ track } = require '@trello/analytics'
isDesktop = require('@trello/browser').isDesktop()
{ InfiniteList } = require 'app/src/components/InfiniteList'
{ useNonPublicIfAvailable } = require 'app/common/lib/util/non-public-fields-filter'
{ TeamTestIds } = require '@trello/test-ids'

emailRegex = /([^"@\s\[\]\(\),:;<>\\]+@[-a-z0-9\.]+\.[a-z]+)/gi
usernameRegex = /^@[a-z0-9_]{3,}$/

class AutocompleteOptions extends React.Component
  shouldComponentUpdate: (nextProps) ->
    return nextProps.isActive

  render: ->
    { displayDetails, displayOrg, selectedOptions, activeIndex, searchResults, selectMemberOption } = @props

    if !searchResults.length
      return null

    selectedOptionIds = selectedOptions.map((d) -> d.id)
    return React.createElement(InfiniteList, {
      itemCount: searchResults.length
      pageSize: 20
      awaitMore: false
      renderItem: (idx, key) =>
        member = searchResults[idx]
        memberAlreadySelected = selectedOptionIds.includes(member.id)
        disabled = memberAlreadySelected or member.joined or member.isDeactivated
        activeMember = activeIndex == idx and !disabled
        React.createElement(AutocompleteMemberAvatar, {
          onMouseDown: (e) => selectMemberOption(e, member)
          displayDetails
          displayOrg
          disabled
          activeMember
          member
          isDesktop
          key
        })
    })

module.exports = class MemberMultiSelectAutocompleteComponent extends React.Component
  constructor: (props) ->
    super
    @isUnmounted = false
    @updateSearchResultList = _.debounce(@updateSearchResultList, 250)
    @searchForMembersPromise = null
    @searchForMembers = @searchForMembers.bind(@)
    @selectMemberOption = @selectMemberOption.bind(@)
    @onInputChange = @onInputChange.bind(@)
    @onInputFocus = @onInputFocus.bind(@)
    @onInputBlur = @onInputBlur.bind(@)
    @onInputKeyUp = @onInputKeyUp.bind(@)
    @onInputKeyDown = @onInputKeyDown.bind(@)
    @onInputPaste = @onInputPaste.bind(@)
    @onAutocompleteKeyDown = @onAutocompleteKeyDown.bind(@)
    @onAutocompleteSubmit = @onAutocompleteSubmit.bind(@)
    @searchCache = {}
    @searchInput = React.createRef()
    @onDocumentClick = @onDocumentClick.bind(@)
    @searchInputFocusPending = null
    @state =
      activeIndex: -1
      isOpen: false
      isFetching: props.loadingOrg
      processingMembers: false
      isActive: true
      isTyping: false
      searchResults: []
      searchText: ''
      shouldFocusOnUpdate: false,
      showMultiBoardGuestAlert: false

  _sanitizeEmail = (email) ->
    return $.trim(email).toLowerCase().match(emailRegex)

  _sanitizeUsername = (username) ->
    return $.trim(username).toLowerCase().replace(/@/g, '')

  componentDidMount: ->
    @searchInputFocusPending = setTimeout(( => @searchInput.current?.focus()), 100)
    document.addEventListener('click', @onDocumentClick)

  componentDidUpdate: (prevProps) ->
    if prevProps.loadingOrg && !@props.loadingOrg && !@state.searchText
      @setState(
        { shouldFocusOnUpdate: true },
        => @searchForMembers(@state.searchText)
      )

    if @state.shouldFocusOnUpdate
      @searchInput.current.focus()
      @setState({ shouldFocusOnUpdate: false })

    # Sometimes we lose focus without calling the onBlur handler, we should
    # update the state in these cases
    if @state.isActive && (document.activeElement != @searchInput.current)
      @setState({
        isOpen: false
        isActive: false
      })

  componentWillUnmount: ->
    # Don't try to focus on the input field since it's getting unmounted
    if @searchInputFocusPending?
      clearTimeout(@searchInputFocusPending)
      @searchInputFocusPending = null

    @isUnmounted = true
    @searchForMembersPromise?.cancel()
    document.removeEventListener('click', @onDocumentClick)

  updateSearchResultList: (searchVal) ->
    if !searchVal
      return

    searchResultList = @searchCache[searchVal]
    if searchResultList
      @receiveSearchResults(searchResultList)
    else
      @searchForMembers searchVal

  searchForMembers: (query, cb) ->
    { onAutocompleteSearch } = @props
    @searchForMembersPromise?.cancel()
    @searchForMembersPromise = Promise.try =>
      if usernameRegex.test(query)
        query = _sanitizeUsername(query)
      else if emailRegex.test(query)
        query = _sanitizeEmail(query)[0]
      @setState({ isFetching: true, isOpen: true })
      onAutocompleteSearch(query)
    .cancellable()
    .then (resultList = []) =>
      resultList.forEach((member) ->
        if member.id
          availableNonPublicAttributes = {
              avatarUrl: useNonPublicIfAvailable(member, 'avatarUrl'),
              fullName: useNonPublicIfAvailable(member, 'fullName'),
              initials: useNonPublicIfAvailable(member, 'initials')
            }
          member = _.extend(member, availableNonPublicAttributes)
      )
      @searchCache[query] = resultList
      @receiveSearchResults(resultList, query)
    .catch Promise.CancellationError, (=> @setState({ isFetching: false }))
    .catch (err) => @setState({ isFetching: false, error: err })

  receiveSearchResults: (searchResults, query) ->
    { emptySearchText } = @props
    searchResults = _.filter searchResults, (result) => result.email || result.username
    @setState({
      isOpen: @state.isTyping
      isFetching: false
      searchResults
    })

  selectMemberOption: (e, member) ->
    e.preventDefault()
    { onSelectMemberOption, shouldFocusOnSelectMemberOption } = @props
    @searchForMembersPromise?.cancel()

    @setState({
      searchText: ''
      isOpen: false
      shouldFocusOnUpdate: shouldFocusOnSelectMemberOption || false
    })
    onSelectMemberOption(member)

  onDocumentClick: (e) ->
    # If the user clicks outside both the red lozenge and the MBG alert, hide it if it is shown
    if (
      $(e.target).closest('.autocomplete-search-results.is-empty, .autocomplete-option').length == 0 &&
      @state.showMultiBoardGuestAlert
    )
      @setState({ showMultiBoardGuestAlert: false })

  onInputBlur: (e) ->
    # Ensure that the input element has actually unfocused. This addresses the case where a the user
    # clicks on a link that opens a new tab / window. This causes a blur event but does not actually
    # change the activeElement.
    if document.activeElement != @searchInput.current
      if emailRegex.test(e.target.value)
        @selectMemberOption(e, _.map(
          _sanitizeEmail(e.target.value), (email) => { email }
        ))

      @setState({
        isOpen: false
        isActive: false
      })

  onInputChange: (e) ->
    e.persist()
    searchText = e.target.value
    @setState({
      searchText,
      isOpen: false
      error: undefined
      showMultiBoardGuestAlert: false
    })
    @updateSearchResultList(searchText)

  onInputFocus: (e) ->
    @setState({ isActive: true })

  onInputKeyUp: (e) ->
    { searchText } = @state
    { selectedOptions } = @props

    if e.key in ['Enter', ',', ' '] and emailRegex.test(e.target.value) # enter, comma, or spacebar
      e.preventDefault()
      @setState({
        isOpen: false
        isTyping: false
      })
      # stop any running search queries
      @searchForMembersPromise?.cancel()
      # map out emails in the case of bulk copy + paste
      @selectMemberOption(e, _.map(
        _sanitizeEmail(e.target.value), (email) => { email }
      ))
    else if e.key is not 'Backspace' or e.target.value or !selectedOptions.length
      @setState({ isTyping: true })

  onInputKeyDown: (e) ->
    { onRemoveMemberOption, selectedOptions } = @props

    if e.key is 'Backspace' and !e.target.value and selectedOptions.length
      onRemoveMemberOption(selectedOptions.length - 1)
      @setState shouldFocusOnUpdate: true

  onInputPaste: (e) ->
    clipboardValue = e.clipboardData.getData('Text')
    if emailRegex.test(clipboardValue)
      @selectMemberOption(e, _.map(
        _sanitizeEmail(clipboardValue), (email) => { email }
      ))

  onAutocompleteKeyDown: (e) ->
    { activeIndex, searchResults } = @state
    switch e.key
      when 'Enter'
        if searchResults[activeIndex] and !searchResults[activeIndex].joined
          @setState({ activeIndex: -1 })
          @selectMemberOption(e, searchResults[activeIndex])
      when 'ArrowRight', 'ArrowDown'
        nextIndex = if activeIndex == searchResults.length - 1 then -1  else activeIndex + 1
        @setState({ activeIndex: nextIndex })
      when 'ArrowLeft', 'ArrowUp'
        prevIndex = if activeIndex == -1 then searchResults.length - 1 else activeIndex - 1
        @setState({ activeIndex: prevIndex })
      else null

  onAutocompleteSubmit: (allowMultiBoardGuests) => (e) =>
    { searchText } = @state
    { onSubmit, selectedOptions, submitDisabled } = @props
    if emailRegex.test(searchText)
      @selectMemberOption(e, _.map(
        _sanitizeEmail(searchText), (email) => { email }
      ))

    @setState({ processingMembers: true })
    onSubmit(allowMultiBoardGuests)
    .then =>
      if !@isUnmounted && !submitDisabled
        @setState({ processingMembers: false })
    .catch (err) =>
      if !@isUnmounted
        @setState({ processingMembers: false, error: err })

  render: t.renderable ->
    {
      activeIndex,
      isActive,
      isFetching,
      isOpen,
      processingMembers,
      searchResults,
      searchText,
      error,
      showMultiBoardGuestAlert
    } = @state
    {
      placeholder,
      displayDetails,
      displayOrg,
      emptySearchText,
      submitText,
      children,
      extraSearchOption,
      selectedOptions,
      onRemoveMemberOption,
      fullWidthButton,
      submitAlwaysEnabled,
      hideDefaultButton
      hideInviteLink
      showMultiboardGuestWarning
      isTemplate
    } = @props

    validEmail = searchText.match(emailRegex)
    atLeastOnePill = selectedOptions.length > 0
    atLeastOneBlockedInvite = _.some(selectedOptions, (member) => member.blockInvite)
    showMultiBoardGuestConfirmation = atLeastOneBlockedInvite && displayOrg && displayOrg.owned()
    showMultiBoardGuestError = atLeastOneBlockedInvite && displayOrg && !displayOrg.owned()
    buttonIsEnabled = (((!atLeastOnePill and validEmail) or atLeastOnePill) and
      !processingMembers and
      (!atLeastOneBlockedInvite || showMultiBoardGuestConfirmation)) or
      submitAlwaysEnabled

    t.div '.multi-select-autocomplete-container', =>
      t.div '.autocomplete-input-container', {
        class: t.classify({
          active: isActive
          processing: processingMembers
          'is-empty': !selectedOptions.length
        })
        onKeyDown: @onAutocompleteKeyDown
      }, =>
        t.div '.autocomplete-selected', =>
          if selectedOptions.length
            selectedOptions.map((member, idx) =>
              t.createElement AutocompleteMemberAvatar,
                {
                  displayDetails: false
                  onRemoveClick: (e) =>
                    e.preventDefault()
                    onRemoveMemberOption(idx)
                  onShowMultiBoardGuestAlert: (shouldShow) => @setState({ showMultiBoardGuestAlert: shouldShow })
                  member
                }
            )

          t.input '.autocomplete-input',
            type: 'text'
            onBlur: @onInputBlur
            onChange: @onInputChange
            onKeyUp: @onInputKeyUp
            onKeyDown: @onInputKeyDown
            onFocus: @onInputFocus
            onPaste: @onInputPaste
            disabled: processingMembers
            placeholder: if selectedOptions.length then '' else placeholder
            value: searchText
            style:
              minWidth: "#{Math.min((searchText?.length * 8) + 2, 264)}px"
            ref: @searchInput
            'data-test-id': TeamTestIds.AddMemberInput

        if isOpen
          if isFetching
            t.div '.autocomplete-search-results', =>
              t.div '.spinner.loading'
          else
            if searchResults.length > 0
              t.div '.autocomplete-search-results', {
                className: if extraSearchOption? then 'has-extra-option' else ''
              }, =>
                t.div '.autocomplete-search-scroll', =>
                  t.tag AutocompleteOptions, {
                    isActive,
                    displayDetails,
                    displayOrg,
                    selectedOptions,
                    activeIndex,
                    searchResults,
                    @selectMemberOption,
                  }
                if extraSearchOption
                  t.addElement extraSearchOption
            else if emptySearchText?
              t.div '.autocomplete-search-results.is-empty', ->
                t.div '.is-empty-text', {
                  class: t.classify({ 'is-empty-text-mod-padding': extraSearchOption? })
                }, ->
                  t.text emptySearchText
                if extraSearchOption
                  t.addElement extraSearchOption
        else if error?
          t.div '.autocomplete-search-results.is-empty', ->
            t.text error.message
        else if showMultiBoardGuestAlert
          t.div '.autocomplete-search-results.is-empty', ->
            t.createElement AutoCompleteMultiBoardGuestAlert, { displayOrg, isDesktop }

      t.addElement children

      if !hideInviteLink
        t.div '.invite-link-actions', ->
          t.span '.invite-with-link', ->
            t.img '.invite-with-link-icon', { src: require('resources/images/icon-link.svg') }
            t.text l(['templates', 'board_member_add_multiple', 'invite-with-link'])

          t.a '.action-link.js-show-invitation-link', { href: '#' }, ->
            t.text l(['templates', 'board_member_add_multiple', 'create-link'])

          t.a '.action-link.js-deactivate-link.hide.js-invitation-link-container', { href: '#' }, ->
            t.text l(['templates', 'board_member_add_multiple', 'disable-link'])

        t.p '.quiet.invite-with-link-description', ->
          if showMultiboardGuestWarning
            t.text l(['templates', 'board_member_add_multiple', 'guests-that-are-already-on-another-team'])

            if !isDesktop
              t.text ' '
              helpUrl = 'https://help.trello.com/article/1123-multi-board-guests'
              t.a
                href: helpUrl
                target: '_blank'
                -> l(['templates', 'select_member', 'learn-more'])
          else if isTemplate
            t.text l(['templates', 'board_member_add_multiple', 'anyone-with-link-can-join-as-template-member'])
          else
            t.text l(['templates', 'board_member_add_multiple', 'anyone-with-link-can-join-as-board-member'])

        t.div '.manage-member-invitation-link.hide.js-invitation-link-container', ->
          t.input '.js-invitation-link',
            type: 'text'
            readOnly: 'readonly'
            placeholder: l(['templates', 'board_member_add_multiple', 'loading'])

          t.button '.primary.js-copy-invitation-link.js-hide-on-copy', ->
            t.text l(['templates', 'board_member_add_multiple', 'copy'])
          t.button '.primary.js-copy-invitation-link.js-show-on-copy.hide', ->
            t.text l(['templates', 'board_member_add_multiple', 'copied'])

      # We'll show the error or the confirmation here, but only admins (owned)
      # can actually go through confirmation
      if showMultiBoardGuestConfirmation || showMultiBoardGuestError
        t.div '.multi-board-guest-message', ->
          t.format 'invite-multi-board-guests-confirmation-message'

      if !hideDefaultButton
        t.button '.autocomplete-btn.primary', {
          class: t.classify({ disabled: !buttonIsEnabled, fullWidthButton: fullWidthButton })
          disabled: !buttonIsEnabled
          onClick: @onAutocompleteSubmit(showMultiBoardGuestConfirmation)
          'data-test-id': TeamTestIds.TeamInviteSubmitButton
        }, ->
          if processingMembers
            t.div '.spinner.loading'
          else
            if showMultiBoardGuestConfirmation
              t.format 'invite-multi-board-guests-confirmation-button'
            else
              t.text submitText